import React, {useState} from 'react';

const AccordionContentWrapper = ({ children }) => {
    return (
        <div
            className="position-relative pb-3 pl-4"
            style={{
                borderLeft: '2px solid black',

            }}
        >
            <div
                className="rounded-circle position-absolute"
                style={{
                    width: '15px',
                    height: '15px',
                    left: '-8px',
                    top: '50%',
                    backgroundColor: 'mediumseagreen',
                    border: '3px solid black',
                    transform: `translateY(-50%)`,
                }}
            ></div>
            <div
                className="p-3 mr-3"
                style={{
                    border: '2px solid green'
                }}
            >
                {children}
            </div>
        </div>
    )
}
export default AccordionContentWrapper;